import storyInflate from '~/modules/routes/storyInflate'
import basicTemplateConfig from '~/modules/services/basicMetaTemplateText.js'
import metaConfig from '~/modules/settings/meta.js'
import {
  inflateStoryWithPicklistDefaults,
  removePicklistOverrides,
} from '~/util/inflate'

export const inflateToANS = (prevStory) => {
  const nextStory = storyInflate(prevStory)
  return Promise.resolve(nextStory)
}

export const inflatePicklists = (prevStory, picklists = {}) => {
  const nextStory = inflateStoryWithPicklistDefaults(
    prevStory,
    picklists ? picklists.picklists : {},
    {
      ...basicTemplateConfig,
      ...Object.keys(metaConfig).reduce(
        (acc, k) => ({ ...acc, [metaConfig[k].key]: metaConfig[k] }),
        {}
      ),
    }
  )
  return Promise.resolve(nextStory)
}

export const inflateMissingContentElements = (prevStory) => {
  prevStory.content_elements = prevStory.content_elements || []
  if (!prevStory.content_elements.length) {
    prevStory.content_elements[0] = {
      type: 'text',
      content: '',
    }
  }
  return Promise.resolve(prevStory)
}

// if we have a default value, use it
// ONLY IF the picklist does not exist or it exists + no default
export const overridePicklists = (prevStory, picklists = {}) => {
  let nextStory = { ...prevStory }
  const [orgNameFromUrl] =
    (window.location.hostname &&
      window.location.hostname.match(/[\w-]+?(?=\.arcpublishing\.com)/)) ||
    ''
  const creditlineHasDefault =
    picklists.picklists &&
    picklists.picklists.creditline &&
    (picklists.picklists.creditline.picklist || []).some(
      (o) => o.default === true
    )
  if (!creditlineHasDefault) {
    nextStory.source = nextStory.source || {}
    nextStory.source.name =
      nextStory.source.name ||
      window.localStorage.getItem('arc.organization') ||
      window.sessionStorage.getItem('arc.organization') ||
      orgNameFromUrl
  }
  nextStory = removePicklistOverrides(
    nextStory,
    nextStory.additional_properties.picklistOverride
  )
  return Promise.resolve(nextStory)
}

// previously, some picklist overrides were set with
// { 'credit.name': true }
// but with ANS you cannot have dots in prop names
export const handleOldFaultyPicklistOverrides = (prevStory) => {
  const config = prevStory.additional_properties.picklistOverride
  const type = Object.prototype.toString.call(config)
  const isObj = type === '[object Object]'
  const isArr = type === '[object Array]'
  let nextConfig
  if (isObj) {
    nextConfig = Object.keys(config).reduce((acc, path) => {
      return [...acc, { path, reset: config[path] }]
    }, [])
  } else if (isArr) {
    nextConfig = config
  }
  const nextStory = {
    ...prevStory,
    additional_properties: {
      ...prevStory.additional_properties,
      picklistOverride: nextConfig,
    },
  }
  return Promise.resolve(nextStory)
}

export const giveContentElementsIds = (prevStory) => {
  const time = new Date().getTime()
  return {
    ...prevStory,
    content_elements: (prevStory.content_elements || []).map((el, i) => {
      return {
        ...el,
        additional_properties: {
          ...(el.additional_properties || {}),
          _id: (el.additional_properties || {})._id
            ? el.additional_properties._id
            : time + i,
        },
      }
    }),
  }
}
